<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">Dashboard</h1>
    <p class="mb-8 leading-normal">
      Hey <b>{{ first_name }} {{ last_name }}</b><br />
      Welcome to street.report, an alpha version for SAAS
      <a class="text-indigo-500 hover:text-orange-600 underline" href="https://street.report">street.report</a>.<br />
      New GIGs platform for street canvass, street teams, flyer and bandit signs distribution.
    </p>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
  },
  layout: Layout,
  props: {
    user: Object,
  },
  data() {
    return {
      first_name: this.user.first_name,
      last_name: this.user.last_name,
      email: this.user.email,
    }
  },
}
</script>
